import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {ContainerDefaultBox} from "./container.default.box";
import {ContainerMrGreenBox} from "./container.mrgreen.box";
import {ContainerSIBox} from "./container.si.box";

export const ContainerBox = styledByTheme(ContainerDefaultBox)
    .forSI(ContainerSIBox)
    .forSICis(ContainerSIBox)
    .forMrGreen(ContainerMrGreenBox)
    .forMrGreenCis(ContainerMrGreenBox).apply();
